import {Column, Entity, OneToOne, PrimaryGeneratedColumn} from "typeorm"

@Entity()
export class NetworkHistoryPG {

	@PrimaryGeneratedColumn()
  id?: number

  @Column({ nullable: true })
	iccid!: string
  
  @Column('datetime')
	timestamp!: Date;

  @Column({ nullable: true })
	network!: string
}